import React, { Component } from "react";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";

import "./Shared.css";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {error: null};

    this.auth = getAuth();
    this.provider = new GoogleAuthProvider();
  }

  signin = () => {
    signInWithPopup(this.auth, this.provider)
      .then((result) => {
        const user = result.user;
        this.props.setUser(user);

      }).catch((error) => {
        this.setState({error: error.message});
      });
  }

  render() {
    return (
      <div className="Content">
        <h2 className="TextCenter">Sign in to get started!</h2>

        <div className="Margin TextCenter"><img className="Pointer" src="/foreword/images/login.png" alt="Login" onClick={this.signin} /></div>
      </div>
    );
  }
}

export default Login;
